export enum CaseType {
  MOTHER = 'MOTHER',
  BABY = 'BABY',
  BOTH = 'BOTH',
  OTHER = 'OTHER',
}
